import { Component, Input } from "@angular/core";
import { TransferComponent } from "../transfer.component";
import { TableKey, TransferItem } from "./transfer-table.type";

@Component({
  selector: "app-transfer-table",
  templateUrl: "./transfer-table.component.html",
  styleUrls: ["./transfer-table.component.scss"],
})
export class TransferTableComponent<T extends TransferItem> {
  @Input() name: TableKey;
  @Input() transfer: TransferComponent<T>;
}
